
const state = () => ({
  dadosForm: []
})

const getters = {
  getDadosForm: (state) => {
    return state.dadosForm
  }
}

const mutations = {
  SET_DADOS_FORM (state, dadosForm) {
    state.dadosForm = dadosForm
  }
}

const actions = {
  setDadosForm ({commit, state}, {id, dadosForm}) {
    id = parseInt(id)

    let forms = state.dadosForm

    forms[id] = dadosForm

    if (!forms[id]) return
    commit('SET_DADOS_FORM', forms)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}